import styled from 'styled-components';
import { breakpoints } from 'theme/variables';

export const FiltersBarWrapper = styled.div`
    margin-bottom: 16px;
    position: relative;
    z-index: 5;

    > div {
        display: flex;
        flex-direction: column;
        gap: 8px;

        ${breakpoints.large} {
            flex-direction: row;
            align-items: center;
        }
    }

    button {
        height: 40px !important;
        min-height: 40px;
        font-size: 0.85rem;
        border-radius: 999px !important;
        padding-left: 18px !important;
        padding-right: 18px !important;
        white-space: nowrap;
    }

    a > button {
        height: 40px !important;
        min-height: 40px;
        border-radius: 999px !important;
    }
`;

export const LeftButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

export const Filters = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    flex-direction: column;
    gap: 8px;

    ${breakpoints.large} {
        flex-direction: row;
        align-items: center;
    }
`;

export const FilterWrapper = styled.div`
    height: 40px !important;
    flex: 1;
    min-width: 0;
    width: 100%;
    overflow: visible !important;
    margin-bottom: 4px;

    ${breakpoints.large} {
        width: auto;
        min-width: 160px;
    }

    .ant-row.ant-legacy-form-item {
        margin: 0 !important;
        margin-bottom: 0 !important;
        height: 40px !important;
    }

    .ant-legacy-form-item-control-wrapper {
        height: 40px !important;
    }

    .ant-legacy-form-item-control {
        height: 40px !important;
        line-height: 40px !important;
    }

    .ant-legacy-form-item-children {
        display: block !important;
        height: 40px !important;
    }

    .ant-select.ant-select-lg {
        width: 100% !important;
        height: 40px !important;
        font-size: 14px !important;
    }

    .ant-select-selector {
        height: 40px !important;
        max-height: 40px !important;
        border-radius: 8px !important;
        display: flex !important;
        align-items: center !important;
        padding: 0 11px !important;
    }

    .ant-select-selection-search {
        height: 40px !important;
        line-height: 40px !important;
    }

    .ant-select-selection-search-input {
        height: 40px !important;
    }

    .ant-select-selection-item {
        height: 40px !important;
        line-height: 40px !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        display: block !important;
        max-width: calc(100% - 40px) !important;
    }

    .ant-select-selection-placeholder {
        height: 40px !important;
        line-height: 40px !important;
        overflow: hidden !important;
    }

    .ant-select-selection-item > div {
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
    }

    .ant-input {
        height: 40px !important;
        border-radius: 8px !important;
    }

    .ant-input-search .ant-input {
        height: 40px !important;
    }

    .ant-input-suffix {
        margin-right: 10px;
    }
`;

export const FiltersButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    flex-wrap: wrap;
`;

export const RightButtons = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: flex-end;
    gap: 8px;

    ${breakpoints.large} {
        flex: 0;
    }
`;
